export const getLastRodeoConfig = () => {
  return {
    prizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420863/imperial-outdoors-trailer-img-01_yft8nz.jpg',
        alt: 'Imperial Outdoors Xplore X195 Travel Trailer',
        title: 'Imperial Outdoors Xplore X195 Travel Trailer',
        value: '$147,000',
        url: 'https://imperial-outdoors.com/',
        sponsorName: 'Imperial Outdoors',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1727735729/Homestead/prizes/bitcoin-01.jpg',
        alt: 'Bitcoin',
        title: '$100,000 in BitCoin',
        value: '$100,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420803/f150-truck-img-01_r9wr47.jpg',
        alt: 'Ford F150 Raptor',
        title: 'Ford F150 Raptor',
        value: '$83,000',
        url: 'https://www.ford.com/trucks/f150/models/f150-raptor/',
        sponsorName: 'Ford',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1744660175/Z252_mower_Salina_KS_2023_071-min_zqwzem.jpg',
        alt: 'Kubota Zero Turn Mower',
        title: 'Kubota - Z252KW-54 - Zero Turn Mower',
        value: '$7,499',
        url: 'https://www.kubotausa.com/',
        sponsorName: 'Kubota',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822684/the-last-rodeo/Clean_WholeBeefStorage-lowres.jpg',
        alt: 'Whole Cow',
        title: 'Whole Cow of Meat with Freezer',
        value: '$6,876',
        sponsorName: 'Whole Cow',
        representativePrizeShown: true,
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822614/the-last-rodeo/0009305_zeon-xp-14-s-110140_625-lowres.jpg',
        alt: 'Warn Winch',
        title: 'Warn ZEON XP 14-S Winch',
        value: '$3,200',
        url: 'https://www.warn.com/',
        sponsorName: 'Warn',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822615/the-last-rodeo/ai-upscale-recovery-kit-lowres.jpg',
        alt: 'Vehicle Recovery Kit',
        title: 'Factor 55 - Vehicle Recovery Kit',
        value: '$1,640',
        url: 'https://factor55.com/',
        sponsorName: 'Factor 55',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1746822614/the-last-rodeo/ultra-hook-lowres.jpg',
        alt: 'Red Ultra Hook',
        title: 'Factor 55 - Red Ultra Hook',
        value: '$280',
        url: 'https://factor55.com',
        sponsorName: 'Factor 55',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420647/AdobeStock_1106386350_y5swrt.jpg',
        alt: 'Gift Card for Ariat Denim',
        title: 'Any Two Pair of Denim Up to $140 Each',
        value: '$280',
        url: 'https://www.ariat.com',
        sponsorName: 'Ariat',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1747153338/F23_MNS_WEST_Montana_Copenhaver_2471_h2zncq.png',
        alt: 'Gift Card for Ariat Cowboy Boots',
        title: 'Any Two Pair of Boots Up to $270 Each',
        value: '$560',
        url: 'https://www.ariat.com',
        sponsorName: 'Ariat',
      },
    ],
  }
}
